// @flow
// THIS FILE IS AUTOMATICALLY GENERATED -- DO NOT EDIT

const Events: Object = {}

// props

type CGPropsCommon = {
  p2p_attempt_id: string,
  p2p_contacts_synced_current_app_permissions: 'not_seen' | 'approved' | 'declined' | 'not_applicable',
  receiver_account_type: string,
  receiver_country: string,
  sender_account_type: 'business' | 'businessSubAccount' | 'personal' | 'premier' | 'unknown',
  sender_country: string,
  session_id: string,
  source: 'top_header_send_link' | 'summary_quick_send' | 'summary_send_again' | 'summary_send_again_more_menu' | 'splitwise' | 'fidelity' | 'summary' | 'activity' | 'wallet' | 'home_screen_send_bottom_nav' | 'home_screen_send_again' | 'home_screen_send_again_search' | 'home_screen_mgm_marketing_card_q420' | 'email_mgm_marketing' | 'send_money_success' | 'congrats_card_mgm' | 'lp_mgm' | 'push_notification' | 'event_tile' | 'activity_transaction_detail' | 'pp_me_profile_send' | 'pp_me_profile_request' | 'checklist_card_mgm' | 'more_menu' | 'paypal_statement' | 'onsite_banner' | 'rewards_hub' | 'profile' | 'mgm_success_screen' | 'sms' | 'paid_media' | 'social' | 'paid_social' | 'sem' | 'mgm_delayed_payout_screen' | 'web_send_money_right_nav' | 'web_request_money_right_nav' | 'web_contacts' | 'web_more' | 'unknown' | 'hawk_web' | 'hawk_mweb' | 'dw_send_again_empty_state' | 'onboarding' | 'dw_dashboard_mgm_zone' | 'messaging' | 'supermenu_send' | 'supermenu_request' | 'stickynav_send' | 'stickynav_request' | 'payhub' | 'getpaidhub' | 'engage_card' | 'app_shortcut',
  sub_flow: 'send_money' | 'request_money' | 'send_again' | 'bill_split' | 'unilateral_claim_money' | 'pay_from_request_member' | 'pay_from_request_guest' | 'qr_scan_casual_seller' | 'qr_scan_casual_seller_fixed_amount' | 'qr_scan_personal' | 'pp_me' | 'money_pool_create' | 'money_pool_contribute_member' | 'money_pool_contribute_guest' | 'donate' | 'hawk' | 'external_partner' | 'unknown' | 'qr_scan_casual_seller_tip_enabled' | 'qr_scan_casual_seller_fixed_and_tip' | 'qr_scan_tip_jar' | 'mgm_send_money' | 'social_commenting' | 'social_messaging' | 'unilateral_send_money' | 'visatag' | 'qrcode',
  ...,
} & $Shape<CGPropsCommon>
type CGPropsCommonAny = {
  p2p_attempt_id?: string,
  p2p_contacts_synced_current_app_permissions?: 'not_seen' | 'approved' | 'declined' | 'not_applicable',
  receiver_account_type?: string,
  receiver_country?: string,
  sender_account_type?: 'business' | 'businessSubAccount' | 'personal' | 'premier' | 'unknown',
  sender_country?: string,
  session_id?: string,
  source?: 'top_header_send_link' | 'summary_quick_send' | 'summary_send_again' | 'summary_send_again_more_menu' | 'splitwise' | 'fidelity' | 'summary' | 'activity' | 'wallet' | 'home_screen_send_bottom_nav' | 'home_screen_send_again' | 'home_screen_send_again_search' | 'home_screen_mgm_marketing_card_q420' | 'email_mgm_marketing' | 'send_money_success' | 'congrats_card_mgm' | 'lp_mgm' | 'push_notification' | 'event_tile' | 'activity_transaction_detail' | 'pp_me_profile_send' | 'pp_me_profile_request' | 'checklist_card_mgm' | 'more_menu' | 'paypal_statement' | 'onsite_banner' | 'rewards_hub' | 'profile' | 'mgm_success_screen' | 'sms' | 'paid_media' | 'social' | 'paid_social' | 'sem' | 'mgm_delayed_payout_screen' | 'web_send_money_right_nav' | 'web_request_money_right_nav' | 'web_contacts' | 'web_more' | 'unknown' | 'hawk_web' | 'hawk_mweb' | 'dw_send_again_empty_state' | 'onboarding' | 'dw_dashboard_mgm_zone' | 'messaging' | 'supermenu_send' | 'supermenu_request' | 'stickynav_send' | 'stickynav_request' | 'payhub' | 'getpaidhub' | 'engage_card' | 'app_shortcut',
  sub_flow?: 'send_money' | 'request_money' | 'send_again' | 'bill_split' | 'unilateral_claim_money' | 'pay_from_request_member' | 'pay_from_request_guest' | 'qr_scan_casual_seller' | 'qr_scan_casual_seller_fixed_amount' | 'qr_scan_personal' | 'pp_me' | 'money_pool_create' | 'money_pool_contribute_member' | 'money_pool_contribute_guest' | 'donate' | 'hawk' | 'external_partner' | 'unknown' | 'qr_scan_casual_seller_tip_enabled' | 'qr_scan_casual_seller_fixed_and_tip' | 'qr_scan_tip_jar' | 'mgm_send_money' | 'social_commenting' | 'social_messaging' | 'unilateral_send_money' | 'visatag' | 'qrcode',
  ...,
}

type CGPropsP2pFlowStarted = {|
  is_ftf_eligible: 'y' | 'n',
|}

type CGPropsP2pSendCapabilityCallOccurred = {|
  deeplink_url: string,
  reason_desc: string,
  response_status: 'success' | 'no_deeplink' | 'failure',
|}

type CGPropsP2pRequestCapabilityCallOccurred = {|
  deeplink_url: string,
  reason_desc: string,
  response_status: 'success' | 'no_deeplink' | 'failure',
|}

type CGPropsP2pContactScreenShown = {|
|}

type CGPropsP2pContactEngaged = {|
  is_amount_filled_y_n: 'y' | 'n',
|} | {|
  is_amount_filled_y_n: 'y' | 'n',
  page_variant: string,
|}

type CGPropsP2pContactAbroadFriendsFamilyPressed = {|
  transition_to: string,
|}

type CGPropsP2pContactSellerProfilePressed = {|
  has_ppme: 'y' | 'n',
|}

type CGPropsP2pContactMoneypoolPressed = {|
|}

type CGPropsP2pContactSelectionPressed = {|
  contact_selected_group: 'top_contacts' | 'your_contacts' | 'people_on_paypal' | 'phone_or_email_only',
  contact_selected_rcvd_count: number,
  contact_selected_row: number,
  contact_selected_sent_count: number,
  has_ppme: 'y' | 'n',
  has_profile_photo: 'y' | 'n',
  is_existing_contact: 'y' | 'n',
  is_favorite_contact: 'y' | 'n',
  is_recent_contact: 'y' | 'n',
  is_synced_contact: 'y' | 'n',
  is_unilateral: 'y' | 'n',
|}

type CGPropsP2pContactTypingStarted = {|
|}

type CGPropsP2pContactTypingStopped = {|
  num_characters_input: string,
  search_type: 'client' | 'service',
|}

type CGPropsP2pContactSearchPressed = {|
|}

type CGPropsP2pContactBlockPromptScreenShown = {|
|}

type CGPropsP2pContactBlockConfirmPressed = {|
|}

type CGPropsP2pContactBlockCancelPressed = {|
|}

type CGPropsP2pContactBlockConfirmationScreenShown = {|
|}

type CGPropsP2pContactBlockedMessageScreenShown = {|
|}

type CGPropsP2pContactPeopleTabPressed = {|
|}

type CGPropsP2pContactBusinessesTabPressed = {|
|}

type CGPropsP2pContactSendToBankPressed = {|
|}

type CGPropsP2pContactCashPickupPressed = {|
|}

type CGPropsP2pAmountBackPressed = {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|} | {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  send_to_flow: string,
  sender_currency: string,
|}

type CGPropsP2pAmountCancelPressed = {|
|}

type CGPropsP2pAmountCurrencyDropdownPressed = {|
  amount_currency_type: 'single_currency' | 'send_currency' | 'receive_currency',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountCurrencySelectionPressed = {|
  amount_currency_type: 'send_currency' | 'receive_currency',
  party: 'sender' | 'receiver',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  updated_currency: string,
|} | {|
  amount_currency_type: 'send_currency' | 'receive_currency',
  party: 'sender' | 'receiver',
  payment_processor: string,
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  updated_currency: string,
|}

type CGPropsP2pAmountCurrencyScreenShown = {|
  amount_currency_type: 'single_currency' | 'send_currency' | 'receive_currency',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountCurrencyAlertShown = {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  updated_currency: string,
|}

type CGPropsP2pAmountCurrencyAlertOkPressed = {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountCurrencyAlertDismissPressed = {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pInternationalCurrencyDisabledDisclosureShown = {|
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountNextPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  gift_theme_added: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receive_currency: string,
  receive_value: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  response_status: string,
  send_currency: string,
  send_to_flow: string,
  send_value: number,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|}

type CGPropsP2pAmountNoteEmojiCarouselScrolled = {|
|}

type CGPropsP2pAmountNoteEmojiPressed = {|
  emoji_used: string,
|}

type CGPropsP2pAmountNoteFocused = {|
|}

type CGPropsP2pAmountNoteTypingStarted = {|
|}

type CGPropsP2pAmountNoteTypingStopped = {|
|}

type CGPropsP2pAmountScreenShown = {|
  is_amount_filled_y_n: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  is_amount_filled_y_n: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  is_amount_filled_y_n: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  send_to_flow: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  is_amount_filled_y_n: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  send_to_flow: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountTypingStarted = {|
  amount_value_type: 'send_value' | 'receive_value',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountTypingStopped = {|
  amount_value_type: 'send_value' | 'receive_value',
  receive_currency: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
|}

type CGPropsP2pAmountStoryNoteEmojiCarouselPressed = {|
  emoji_used: string,
|}

type CGPropsP2pAmountThemeEntryPointPressed = {|
|}

type CGPropsP2pAmountNoteEntryPointPressed = {|
|}

type CGPropsP2pAmountGifEntryPointPressed = {|
|}

type CGPropsP2pAmountGifSelectedPressed = {|
  gif_search_keyword: string,
  gif_source: 'default_list' | 'search_list',
  media_id_added: string,
|}

type CGPropsP2pAmountGifMenuPressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountGifMenuReplacePressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountGifMenuRemovePressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountGifMenuCancelPressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountTooltipShown = {|
|}

type CGPropsP2pAmountStoryNoteScreenShown = {|
  media_added: 'y' | 'n',
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receiver_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receiver_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteNextPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_suggested_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|}

type CGPropsP2pAmountStoryNoteBackPressed = {|
|}

type CGPropsP2pAmountStoryNoteTypingStarted = {|
|}

type CGPropsP2pAmountStoryNoteInputFieldFocused = {|
  receive_currency: string,
  receive_value: number,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  send_value: number,
  sender_currency: string,
|}

type CGPropsP2pAmountStoryNoteThemeEntryPointPressed = {|
  note_screen_design: 'CONTROL' | 'T1_MAGIC_WAND' | 'T2_CAROUSEL' | 'T3_LABEL' | 'T4_GIFT',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteGifEntryPointPressed = {|
  note_screen_design: 'CONTROL' | 'T1_MAGIC_WAND' | 'T2_CAROUSEL' | 'T3_LABEL' | 'T4_GIFT',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteGifSelectedPressed = {|
  gif_source: 'default_list' | 'search_list',
  media_id_added: string,
|}

type CGPropsP2pAmountStoryNoteGifMenuPressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountStoryNoteGifMenuReplacePressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountStoryNoteGifMenuRemovePressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountStoryNoteGifMenuCancelPressed = {|
  media_id_added: string,
|}

type CGPropsP2pAmountStoryNoteMediaSelectedPressed = {|
  gif_source: 'default_list' | 'search_list',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteMediaMenuPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteMediaMenuReplacePressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteMediaMenuRemovePressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountStoryNoteMediaMenuCancelPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountAlertOccurred = {|
|}

type CGPropsP2pAmountStoryNoteErrorOccurred = {|
|}

type CGPropsP2pAmountGiftPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountGiftThemePressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pAmountGiftThemeSavePressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  receive_currency: string,
  receiver_account_type: string,
  receiver_country: string,
  receiver_currency: string,
  receiver_metadata_shown: string,
  send_currency: string,
  sender_currency: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
|}

type CGPropsP2pFxBackPressed = {|
|}

type CGPropsP2pBrowseThemeOptionsShown = {|
  category_options_offered_count: number,
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  theme_options_offered_count: number,
|} | {|
  category_options_offered_count: number,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  theme_options_offered_count: number,
|}

type CGPropsP2pBrowseThemeOptionsSelection = {|
  category_carousel_theme_order: number,
  category_id: string,
  category_name: string,
  category_vertical_order: number,
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  skin_tone: string,
  theme_name: string,
|} | {|
  category_carousel_theme_order: number,
  category_id: string,
  category_name: string,
  category_vertical_order: number,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  skin_tone: string,
  theme_name: string,
|}

type CGPropsP2pBrowseThemeOptionsDismissed = {|
|}

type CGPropsP2pBrowseThemeOptionsCategoryScrollRight = {|
  category_name: string,
  scroll_depth: number,
  scroll_threshold: string,
|}

type CGPropsP2pBrowseThemeOptionsCategoryScrollDown = {|
  scroll_depth: number,
  scroll_threshold: string,
|}

type CGPropsP2pBrowseThemeOptionsSkinToneSelectorShown = {|
  skin_tone_options_offered: number,
|}

type CGPropsP2pBrowseThemeOptionsSkinToneSelected = {|
  skin_tone: string,
|}

type CGPropsP2pBrowseThemeOptionsSkinToneSelectorLongPress = {|
  skin_tone: string,
|}

type CGPropsP2pFiUnavailablePaymentMethodsScreenShown = {|
  fi_count_shown: number,
  screen_state: 'no_fi_available' | 'fi_available',
|}

type CGPropsP2pFiUnavailablePaymentMethodsScreenPrimaryButtonPressed = {|
  button_name: 'ok' | 'add_fi',
|}

type CGPropsP2pFiScreenUnavailablePaymentMethodsLinkPressed = {|
|}

type CGPropsP2pFiUnavailablePaymentMethodsScreenBackPressed = {|
|}

type CGPropsP2pAddFiScreenShown = {|
|}

type CGPropsP2pFiScreenDismissed = {|
|}

type CGPropsP2pFiWarningClosePressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2pFiWarningContinuePressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2pFiWarningScreenShown = {|
  chosen_fi_id: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  note_character_length: number,
  receiver_currency: string,
  sender_currency: string,
|} | {|
  chosen_fi_id: string,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  note_character_length: number,
  receiver_currency: string,
  sender_currency: string,
|}

type CGPropsP2pFiWarningUpdatePressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2pFiWarningTermsPressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2pFiAddPressed = {|
|}

type CGPropsP2pFiBackPressed = {|
|}

type CGPropsP2pFiScreenShown = {|
  balance_available: 'y' | 'n',
  default_fi: string,
  fi_eligible_count: number,
  note_character_length: number,
  page_alert_shown: 'declined_fi' | 'none',
  payment_type: 'purchase' | 'personal',
  receiver_currency: string,
  sender_currency: string,
  unavailable_payment_methods_link_shown: 'y' | 'n',
|} | {|
  balance_available: 'y' | 'n',
  default_fi: string,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fi_eligible_count: number,
  note_character_length: number,
  page_alert_shown: 'declined_fi' | 'none',
  payment_type: 'purchase' | 'personal',
  receiver_currency: string,
  sender_currency: string,
  unavailable_payment_methods_link_shown: 'y' | 'n',
|}

type CGPropsP2pFiNextPressed = {|
  balance_toggle: 'y' | 'n',
  balance_used: 'y' | 'n',
  default_fi: string,
  fi_has_bufs: 'y' | 'n',
  fi_id: string,
  fi_name: string,
  fi_selected: string,
  fi_type: string,
  funding_option: string,
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_currency: string,
  sender_currency: string,
|} | {|
  balance_toggle: 'y' | 'n',
  balance_used: 'y' | 'n',
  default_fi: string,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fi_has_bufs: 'y' | 'n',
  fi_id: string,
  fi_name: string,
  fi_selected: string,
  fi_type: string,
  funding_option: string,
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_currency: string,
  sender_currency: string,
|}

type CGPropsP2pFiSelectionPressed = {|
  fi_has_bufs: 'y' | 'n',
  fi_selection_switched: 'y' | 'n',
  funding_option: string,
|} | {|
  fi_has_bufs: 'y' | 'n',
  fi_selection_switched: 'y' | 'n',
  fi_warning_type: ['cash_advance', 'open_banking', '3ds', 'declined_fi', 'echeck'],
  funding_option: string,
|}

type CGPropsP2pFiSelectionWarningPressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2pFiContingencyCalled = {|
  chosen_fi_id: string,
  contingency_return: string,
|}

type CGPropsP2pFiContingencyResolved = {|
  chosen_fi_id: string,
  contingency_return: string,
  status: 'success' | 'failure' | 'echeck' | 'invalid_credentials',
|}

type CGPropsP2pReviewNoteBackPressed = {|
|}

type CGPropsP2pReviewNoteDonePressed = {|
  note_character_length: number,
|} | {|
  emoji_count: number,
  emoji_included: string,
  note_character_length: number,
|}

type CGPropsP2pReviewNoteScreenShown = {|
|}

type CGPropsP2pReviewNoteTypingStarted = {|
|}

type CGPropsP2pPaymentTypeBackPressed = {|
|}

type CGPropsP2pPaymentTypeTogglePressed = {|
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  suggested_protection_design: string,
|}

type CGPropsP2pPaymentTypeCancelPressed = {|
  protection_design: string,
  suggested_protection_design: string,
|}

type CGPropsP2pPaymentTypeScreenShown = {|
  note_character_length: number,
  payment_type_selection_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  note_character_length: number,
  payment_type_selection_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  note_character_length: number,
  page_variant: string,
  payment_type_selection_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  note_character_length: number,
  page_variant: string,
  payment_type_selection_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|}

type CGPropsP2pPaymentTypeTransitionMessage = {|
|}

type CGPropsP2pPaymentTypeTermsPressed = {|
  protection_design: string,
  suggested_protection_design: string,
|}

type CGPropsP2pPaymentTypeFeePayerOptionPressed = {|
  protection_design: string,
  suggested_protection_design: string,
|} | {|
  fee_payer: 'payer' | 'payee',
  protection_design: string,
  suggested_protection_design: string,
|}

type CGPropsP2pPaymentTypeContinuePressed = {|
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|} | {|
  fee_payer: 'payer' | 'payee',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  suggested_protection_design: string,
|}

type CGPropsP2pProtectionOverpanelShown = {|
|}

type CGPropsP2pProtectionOverpanelBackPressed = {|
|}

type CGPropsP2pProtectionOverpanelDismissed = {|
|}

type CGPropsP2pProtectionOverpanelGnsPressed = {|
|}

type CGPropsP2pProtectionOverpanelFnfPressed = {|
|}

type CGPropsP2pSellerFeeDisclaimerScreenShown = {|
|}

type CGPropsP2pSellerFeeDisclaimerOkPressed = {|
|}

type CGPropsP2pSellerFeeDisclaimerTermsPressed = {|
|}

type CGPropsP2pReviewScreenDismissed = {|
|}

type CGPropsP2pReviewAboutSellerFeePressed = {|
|}

type CGPropsP2pReviewClosePressed = {|
  send_to_flow: string,
|}

type CGPropsP2pReviewAddNotePressed = {|
|}

type CGPropsP2pReviewBackPressed = {|
|}

type CGPropsP2pReviewScreenShown = {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds' | 'echeck',
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  default_fi_type: string,
  disclaimer_shown: 'none' | 'fraud_warning',
  estimated_funds_arrival_time: number,
  fee: string,
  fi_has_bufs: 'y' | 'n',
  fi_name: string,
  is_check_box_shown: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'qrcode',
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|}

type CGPropsActiveConsentDisclaimerShown = {|
  flow: 'p2p_send_money' | 'p2p_request_money' | 'p2p_bill_split',
  policy_major_version: string,
  policy_minor_version: string,
|}

type CGPropsActiveConsentDisclaimerAgreePressed = {|
  flow: 'p2p_send_money' | 'p2p_request_money' | 'p2p_bill_split',
  policy_major_version: string,
  policy_minor_version: string,
|}

type CGPropsActiveConsentDisclaimerTermsPressed = {|
  flow: 'p2p_send_money' | 'p2p_request_money' | 'p2p_bill_split',
  policy_major_version: string,
  policy_minor_version: string,
|}

type CGPropsP2pReviewFiPressed = {|
|}

type CGPropsP2pReviewProtectionChoicePressed = {|
|}

type CGPropsP2pReviewSubmitPressed = {|
  balance_used: 'y' | 'n',
  fee: string,
  fi_name: string,
  fi_type: string,
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  fee: string,
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fi_name: string,
  fi_type: string,
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|} | {|
  balance_used: 'y' | 'n',
  fee: string,
  fee_payer: 'payer' | 'payee',
  fi_name: string,
  fi_type: string,
  gns_consent: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  payment_type_review_message: 'y' | 'n',
  protection_design: string,
  receiver_currency: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
|}

type CGPropsP2pReviewPaymentTypeTermsPressed = {|
|}

type CGPropsP2pReviewShippingAddressPressed = {|
|}

type CGPropsP2pReviewWarningPressed = {|
  fi_warning_type: 'cash_advance' | 'open_banking' | '3ds',
|}

type CGPropsP2p24HrHoldCancelPressed = {|
  page_variant: string,
|}

type CGPropsP2p24HrHoldContinuePressed = {|
  page_variant: string,
|}

type CGPropsP2p24HrHoldScreenShown = {|
  action: string,
  page_variant: string,
|}

type CGPropsP2pSuccessDonePressed = {|
  send_to_flow: string,
|}

type CGPropsP2pSuccessScreenShown = {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  fee_payer: 'payer' | 'payee',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  tip_amount: string,
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  feedback_available: 'control' | 't1' | 't2',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|} | {|
  design_mgm: 'y' | 'n',
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  page_variant: 'qr_moonshot' | 'p2p_existing' | 'growth_xsell' | 'p2p_echeck' | 'qrcode' | 'p2p_ofac' | 'p2p_iat_unilateral',
  payment_type: 'purchase' | 'personal',
  protection_design: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  send_to_flow: string,
  sender_amount: string,
  sender_currency: string,
  sticker_added: 'y' | 'n',
  story_id: string,
  story_structure_design: 'CONTROL_APP' | 'DESIGN_STRUCTURE_ACTIVATED_APP' | 'DESIGN_STRUCTURE_THEME_ACTIVATED_APP' | 'THEME_ACTIVATED_APP',
  suggested_protection_design: string,
  suggestion_emoji_selected: string,
  suggestion_logic_type: 'trending' | 'keyword',
  suggestion_mapped_keyword: string,
  suggestion_theme_selected: string,
  suggestion_used: 'y' | 'n',
  txn_id: string,
|}

type CGPropsP2pSuccessMgmTermsPressed = {|
|}

type CGPropsP2pSuccessRestartPressed = {|
|}

type CGPropsP2pSuccessSummaryPressed = {|
|}

type CGPropsP2pSuccessInviteFriendPressed = {|
|}

type CGPropsP2pSuccessScreenFeedbackPressed = {|
|}

type CGPropsP2pRequestMoneySellerProfileEntryScreenShown = {|
  response_duration: string,
|}

type CGPropsP2pRequestMoneySellerProfileEntryCreatePressed = {|
|}

type CGPropsP2pRequestMoneySellerProfileEntryDismissPressed = {|
|}

type CGPropsP2pFailedCustomerInteractionOccurred = {|
  error_code: string,
  error_description: string,
  screen: string,
|}

type CGPropsP2pNonVisibleErrorOccurred = {|
  description: string,
  file_name: string,
  function_name: string,
|}

type CGPropsP2pPhysicalBackButtonPressed = {|
  screen: string,
|}

type CGPropsP2pStoryLandingScreenLoadingCalled = {|
  payment_type: 'purchase' | 'personal',
  story_id: string,
|}

type CGPropsP2pStoryLandingScreenShown = {|
  group_request_id: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  request_id: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  status: 'pending' | 'cancelled' | 'completed',
  story_id: string,
  two_way_experience_active: 'y' | 'n',
  txn_id: string,
  user_role: 'requester' | 'requestee' | 'payer' | 'payee',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  group_request_id: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  request_id: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  status: 'pending' | 'cancelled' | 'completed',
  story_id: string,
  two_way_experience_active: 'y' | 'n',
  txn_id: string,
  user_role: 'requester' | 'requestee' | 'payer' | 'payee',
|}

type CGPropsP2pStoryLandingBackButtonPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
|}

type CGPropsP2pStoryLandingDonePressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
|}

type CGPropsP2pStoryLandingViewDetailsPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  two_way_experience_active: 'y' | 'n',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_character_length: number,
  payment_type: 'purchase' | 'personal',
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  two_way_experience_active: 'y' | 'n',
|}

type CGPropsP2pStoryLandingPayRequestPressed = {|
  group_request_id: string,
  request_id: string,
  source: string,
  story_id: string,
|}

type CGPropsP2pStoryLandingCancelRequestPressed = {|
  group_request_id: string,
  request_id: string,
  source: string,
  story_id: string,
  user_role: 'requester' | 'requestee',
|}

type CGPropsP2pStoryLandingConfirmCancelRequestMenuPressed = {|
  group_request_id: string,
  request_id: string,
  source: string,
  story_id: string,
  user_role: 'requester' | 'requestee',
|}

type CGPropsP2pStoryLandingDismissRequestCancelMenuPressed = {|
  group_request_id: string,
  request_id: string,
  source: string,
  story_id: string,
  user_role: 'requester' | 'requestee',
|}

type CGPropsP2pStoryLandingScreenDeclineRequestMenuShown = {|
  group_request_id: string,
  request_id: string,
  source: string,
  story_id: string,
  user_role: 'requester' | 'requestee',
|}

type CGPropsP2pStoryLandingQuickReactionStartButtonPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  previous_quick_reaction_selected: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  previous_quick_reaction_selected: string,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|}

type CGPropsP2pStoryLandingMessageStartButtonPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|}

type CGPropsP2pStoryLandingViewMessagesPressed = {|
|}

type CGPropsP2pStoryLandingChatThreadOpenButtonPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
|}

type CGPropsP2pStoryLandingQuickReactionOptionsShown = {|
  reaction_options_offered_count: number,
  reaction_options_offered_value: string,
|}

type CGPropsP2pStoryLandingQuickReactionOptionsPressed = {|
  reaction_options_selected: string,
|}

type CGPropsP2pStoryLandingQuickReactionOptionsDismissed = {|
  previous_quick_reaction_selected: string,
  reaction_options_offered_count: number,
  reaction_options_offered_value: string,
|}

type CGPropsP2pStoryLandingQuickReactionFailedShown = {|
|}

type CGPropsP2pStoryLandingMessageThreadShown = {|
  blocked_relationship: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
  txn_id: string,
|} | {|
  blocked_relationship: string,
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
  txn_id: string,
|}

type CGPropsP2pStoryLandingMessageThreadErrorShown = {|
  error_code: string,
  error_description: string,
|}

type CGPropsP2pStoryLandingMessageThreadDisclaimerLinkPressed = {|
|}

type CGPropsP2pStoryLandingMessageThreadDismissed = {|
  dismiss_method: 'x_button' | 'tap_background' | 'swipe_down' | 'web_back_button' | 'web_tab_closed' | 'web_nav_away',
|}

type CGPropsP2pStoryLandingMessageSendPressed = {|
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
  user_role: 'money_sender' | 'money_receiver' | 'money_requestor',
|} | {|
  emoji_added: 'y' | 'n',
  emoji_added_count: number,
  emoji_used: string,
  media_added: 'y' | 'n',
  media_id_added: string,
  media_type: 'none' | 'sticker' | 'theme',
  note_added: 'y' | 'n',
  note_character_length: number,
  receiver_amount_local_currency: string,
  receiver_currency: string,
  sender_amount: string,
  sender_currency: string,
  source: string,
  story_id: string,
  transaction_type: 'purchase' | 'personal',
  user_role: 'money_sender' | 'money_receiver' | 'money_requestor',
|}

type CGPropsP2pStoryLandingMessageThreadProfilePressed = {|
|}

type CGPropsP2pStoryLandingMessageThreadRefreshActionShown = {|
|}

type CGPropsP2pStoryLandingMessageThreadRefreshDragged = {|
|}

type CGPropsP2pStoryLandingMessageMoreOptionsMenuPressed = {|
|}

type CGPropsP2pStoryLandingMessageMoreOptionsMenuBlockPressed = {|
|}

type CGPropsP2pStoryLandingMessageMoreOptionsMenuReportPressed = {|
|}

type CGPropsP2pStoryLandingMessageBlockConfirmationAlertShown = {|
|}

type CGPropsP2pStoryLandingMessageBlockConfirmationAlertBlockPressed = {|
  blocked_user: string,
  blocking_user: string,
  story_id: string,
  txn_id: string,
|}

type CGPropsP2pStoryLandingMessageBlockConfirmationAlertCancelPressed = {|
|}

type CGPropsP2pStoryLandingMessageBlockSuccessShown = {|
|}

type CGPropsP2pStoryLandingMessageBlockSuccessClosePressed = {|
|}

type CGPropsP2pStoryLandingMessageBlockFailedShown = {|
|}

type CGPropsP2pStoryLandingMessageBlockFailedClosePressed = {|
|}

type CGPropsP2pAppStoreScreenShown = {|
|}

type CGPropsP2pAppStoreClosePressed = {|
|}

type CGPropsP2pAppStoreDownloadPressed = {|
|}

type CGPropsP2pClientServerDecisionReached = {|
  decision_action: string,
  default_payment_type: string,
  payment_type_selection_behavior: string,
  product_entry_point: string,
  reassess_capabilities: 'y' | 'n',
  service_client_match: 'y' | 'n',
  ui_variant: string,
  usage_mode: string,
|}

type CGPropsP2pMgmInterstitialScreenShown = {|
|}

type CGPropsP2pMgmTermsPressed = {|
|}

type CGPropsP2pMgmInterstitialNextPressed = {|
|}

type CGPropsP2pMgmInterstitialBackPressed = {|
|}

type CGPropsP2pMgmReceiverCriteriaScreenShown = {|
|}

type CGPropsP2pMgmReceiverCriteriaAddFiPressed = {|
|}

type CGPropsP2pMgmReceiverCriteriaSpendPressed = {|
|}

type CGPropsP2pMgmReceiverCriteriaBackPressed = {|
|}

type CGPropsP2pMgmReceiverDelayedPayoutScreenInvitePressed = {|
|}

type CGPropsP2pMgmReceiverDelayedPayoutScreenShown = {|
|}

type CGPropsP2pRtrScreenShown = {|
|}

type CGPropsP2pRtrScreenBackPressed = {|
|}

type CGPropsP2pRtrScreenNextPressed = {|
|}

type CGPropsP2pExternalEntryOccurred = {|
  flow_from: 'unknown' | 'summary' | 'mpp' | 'pools' | 'ppme' | 'donate' | 'outlook' | 'xb' | 'hawk' | 'hawk-ppcp' | 'marketing' | 'tricount' | 'defaults' | 'authflow' | 'wallet' | 'profile' | 'phoneconfirmation' | 'pisp' | 'homeinfo' | 'mgm',
|} | {|
  flow_from: 'unknown' | 'summary' | 'mpp' | 'pools' | 'ppme' | 'donate' | 'outlook' | 'xb' | 'hawk' | 'hawk-ppcp' | 'marketing' | 'tricount' | 'defaults' | 'authflow' | 'wallet' | 'profile' | 'phoneconfirmation' | 'pisp' | 'homeinfo' | 'mgm',
  http_params: string,
|}

type CGPropsP2pSearchResultContactSelectionPressed = {|
  contact_selected_group: 'top_contacts' | 'your_contacts' | 'people_on_paypal' | 'phone_or_email_only',
  contact_selected_rcvd_count: number,
  contact_selected_row: number,
  contact_selected_sent_count: number,
  has_ppme: 'y' | 'n',
  has_profile_photo: 'y' | 'n',
  is_existing_contact: 'y' | 'n',
  is_favorite_contact: 'y' | 'n',
  is_location_shown: 'y' | 'n',
  is_recent_contact: 'y' | 'n',
  is_synced_contact: 'y' | 'n',
  is_unilateral: 'y' | 'n',
  mutual_contacts_count: string,
  mutual_contacts_status: string,
  num_characters_input: number,
|}

type CGPropsP2pGuestPaymentFormScreenShown = {|
|}

type CGPropsP2pGuestPaymentFormAccountTogglePressed = {|
  toggle_on: 'y' | 'n',
|}

type CGPropsP2pGuestPaymentFormContinuePressed = {|
  toggle_on: 'y' | 'n',
|}

type CGPropsP2pGuestPaymentFormDismissPressed = {|
|}

type CGPropsP2pGuestPaymentReviewScreenShown = {|
|}

type CGPropsP2pGuestPaymentReviewPayPressed = {|
|}

type CGPropsP2pGuestPaymentSuccessScreenShown = {|
|}

type CGPropsP2pGuestPaymentAccountUpgradeSuccessScreenShown = {|
|}

type CGPropsP2pFirstTransactionFreeInterstitialShown = {|
|}

type CGPropsP2pFirstTransactionFreeInterstitialSendPressed = {|
|}

type CGPropsP2pFirstTransactionFreeInterstitialDismissPressed = {|
  dismiss_method: 'close' | 'outside',
|}

type CGPropsP2pContactFirstTransactionFreeTermsPressed = {|
|}

type CGPropsP2pCheckoutSuccessContinueShoppingPressed = {|
  store_id: string,
  txn_id: string,
|}

type CGPropsP2pCheckoutSuccessScreenShown = {|
  store_id: string,
  txn_id: string,
|}

type CGPropsVisatagBalanceScreenShown = {|
  has_balance: 'y' | 'n',
|}

type CGPropsVisatagBalanceContinuePressed = {|
|}

type CGPropsVisatagBalanceAddMoneyPressed = {|
|}

type CGPropsVisatagBalanceCancelPressed = {|
|}

type CGPropsVisatagContactScreenShown = {|
  send_to_flow: string,
|}

type CGPropsVisatagContactContactFieldPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagContactNextPressed = {|
  response_status: 'success' | 'failure',
|} | {|
  response_status: 'success' | 'failure',
  send_to_flow: string,
|}

type CGPropsVisatagContactBackPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagPhoneValidationScreenShown = {|
  send_to_flow: string,
|}

type CGPropsVisatagPhoneValidationSkipPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagPhoneValidationConfirmPressed = {|
  response_status: 'success' | 'failure',
|} | {|
  response_status: 'success' | 'failure',
  send_to_flow: string,
|}

type CGPropsVisatagPhoneValidationBackPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagDisallowPaypalPaynameScreenShown = {|
  send_to_flow: string,
|}

type CGPropsVisatagDisallowPaypalPaynameP2pPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagDisallowPaypalPaynameBackPressed = {|
  send_to_flow: string,
|}

type CGPropsVisatagPhoneValidationSuccessScreenShown = {|
  send_to_flow: string,
|}

type CGPropsP2pPersonalProfileCreateContinuePressed = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateFailureReturned = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateFormErrorOccurred = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateEditPressed = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateNotNowPressed = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateScreenShown = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateSuccessReturned = {|
  entry_point: string,
|}

type CGPropsP2pPersonalProfileCreateSuggestionPressed = {|
  entry_point: string,
|}

// common props

export let commonProps: Object = {}
Events.initCommonProps = (props: CGPropsCommon) => {
  commonProps = {
    product: 'p2p',
    ...props,
  }
}
Events.updateCommonProps = (props: CGPropsCommonAny) => {
  commonProps = {
    ...commonProps,
    ...props,
  }
}

// events

Events.p2p_flow_started = (props: CGPropsP2pFlowStarted) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_flow_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, is_ftf_eligible',
  ...props,
})

Events.p2p_send_capability_call_occurred = (props: CGPropsP2pSendCapabilityCallOccurred) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_send_capability_call_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, deeplink_url, reason_desc, response_status',
  ...props,
})

Events.p2p_request_capability_call_occurred = (props: CGPropsP2pRequestCapabilityCallOccurred) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_request_capability_call_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, deeplink_url, reason_desc, response_status',
  ...props,
})

Events.p2p_contact_screen_shown = (props: CGPropsP2pContactScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_contact_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_engaged = (props: CGPropsP2pContactEngaged) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_engaged',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, page_variant, is_amount_filled_y_n',
  ...props,
})

Events.p2p_contact_abroad_friends_family_pressed = (props: CGPropsP2pContactAbroadFriendsFamilyPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_abroad_friends_family_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, transition_to',
  ...props,
})

Events.p2p_contact_seller_profile_pressed = (props: CGPropsP2pContactSellerProfilePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_seller_profile_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, has_ppme',
  ...props,
})

Events.p2p_contact_moneypool_pressed = (props: CGPropsP2pContactMoneypoolPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_moneypool_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_selection_pressed = (props: CGPropsP2pContactSelectionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_selection_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, contact_selected_row, is_recent_contact, is_existing_contact, is_favorite_contact, has_ppme, has_profile_photo, is_unilateral, is_synced_contact, contact_selected_group, contact_selected_sent_count, contact_selected_rcvd_count',
  ...props,
})

Events.p2p_contact_typing_started = (props: CGPropsP2pContactTypingStarted) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_typing_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_typing_stopped = (props: CGPropsP2pContactTypingStopped) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_typing_stopped',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, num_characters_input, search_type',
  ...props,
})

Events.p2p_contact_search_pressed = (props: CGPropsP2pContactSearchPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_search_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_block_prompt_screen_shown = (props: CGPropsP2pContactBlockPromptScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_contact_block_prompt_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_block_confirm_pressed = (props: CGPropsP2pContactBlockConfirmPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_block_confirm_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_block_cancel_pressed = (props: CGPropsP2pContactBlockCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_block_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_block_confirmation_screen_shown = (props: CGPropsP2pContactBlockConfirmationScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_contact_block_confirmation_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_blocked_message_screen_shown = (props: CGPropsP2pContactBlockedMessageScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_contact_blocked_message_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_people_tab_pressed = (props: CGPropsP2pContactPeopleTabPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_people_tab_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_businesses_tab_pressed = (props: CGPropsP2pContactBusinessesTabPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_businesses_tab_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_send_to_bank_pressed = (props: CGPropsP2pContactSendToBankPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_send_to_bank_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_contact_cash_pickup_pressed = (props: CGPropsP2pContactCashPickupPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_cash_pickup_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_back_pressed = (props: CGPropsP2pAmountBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, send_to_flow',
  ...props,
})

Events.p2p_amount_cancel_pressed = (props: CGPropsP2pAmountCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_currency_dropdown_pressed = (props: CGPropsP2pAmountCurrencyDropdownPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_dropdown_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, amount_currency_type',
  ...props,
})

Events.p2p_amount_currency_selection_pressed = (props: CGPropsP2pAmountCurrencySelectionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_selection_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, party, updated_currency, sender_currency, payment_processor, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, amount_currency_type',
  ...props,
})

Events.p2p_amount_currency_screen_shown = (props: CGPropsP2pAmountCurrencyScreenShown) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, amount_currency_type',
  ...props,
})

Events.p2p_amount_currency_alert_shown = (props: CGPropsP2pAmountCurrencyAlertShown) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_alert_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, updated_currency',
  ...props,
})

Events.p2p_amount_currency_alert_ok_pressed = (props: CGPropsP2pAmountCurrencyAlertOkPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_alert_ok_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_amount_currency_alert_dismiss_pressed = (props: CGPropsP2pAmountCurrencyAlertDismissPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_currency_alert_dismiss_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_international_currency_disabled_disclosure_shown = (props: CGPropsP2pInternationalCurrencyDisabledDisclosureShown) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_international_currency_disabled_disclosure_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_amount_next_pressed = (props: CGPropsP2pAmountNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_added_count, emoji_used, note_character_length, emoji_added, emoji_suggested_count, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, sticker_added, media_id_added, story_structure_design, story_id, media_type, media_added, suggestion_logic_type, suggestion_mapped_keyword, suggestion_emoji_selected, suggestion_theme_selected, suggestion_used, response_status, send_currency, receive_currency, receiver_metadata_shown, send_value, receive_value, gift_theme_added, send_to_flow',
  ...props,
})

Events.p2p_amount_note_emoji_carousel_scrolled = (props: CGPropsP2pAmountNoteEmojiCarouselScrolled) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_emoji_carousel_scrolled',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_note_emoji_pressed = (props: CGPropsP2pAmountNoteEmojiPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_emoji_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_used',
  ...props,
})

Events.p2p_amount_note_focused = (props: CGPropsP2pAmountNoteFocused) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_focused',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_note_typing_started = (props: CGPropsP2pAmountNoteTypingStarted) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_typing_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_note_typing_stopped = (props: CGPropsP2pAmountNoteTypingStopped) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_typing_stopped',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_screen_shown = (props: CGPropsP2pAmountScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_amount_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, is_amount_filled_y_n, page_variant, story_structure_design, media_id_added, media_type, media_added, send_currency, receive_currency, receiver_metadata_shown, send_to_flow',
  ...props,
})

Events.p2p_amount_typing_started = (props: CGPropsP2pAmountTypingStarted) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_typing_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, amount_value_type',
  ...props,
})

Events.p2p_amount_typing_stopped = (props: CGPropsP2pAmountTypingStopped) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_typing_stopped',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, amount_value_type',
  ...props,
})

Events.p2p_amount_story_note_emoji_carousel_pressed = (props: CGPropsP2pAmountStoryNoteEmojiCarouselPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_emoji_carousel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_used',
  ...props,
})

Events.p2p_amount_theme_entry_point_pressed = (props: CGPropsP2pAmountThemeEntryPointPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_theme_entry_point_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_note_entry_point_pressed = (props: CGPropsP2pAmountNoteEntryPointPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_note_entry_point_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_gif_entry_point_pressed = (props: CGPropsP2pAmountGifEntryPointPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_entry_point_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_gif_selected_pressed = (props: CGPropsP2pAmountGifSelectedPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_selected_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, gif_source, gif_search_keyword, media_id_added',
  ...props,
})

Events.p2p_amount_gif_menu_pressed = (props: CGPropsP2pAmountGifMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_gif_menu_replace_pressed = (props: CGPropsP2pAmountGifMenuReplacePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_menu_replace_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_gif_menu_remove_pressed = (props: CGPropsP2pAmountGifMenuRemovePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_menu_remove_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_gif_menu_cancel_pressed = (props: CGPropsP2pAmountGifMenuCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gif_menu_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_tooltip_shown = (props: CGPropsP2pAmountTooltipShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_amount_tooltip_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_story_note_screen_shown = (props: CGPropsP2pAmountStoryNoteScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_amount_story_note_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_story_note_next_pressed = (props: CGPropsP2pAmountStoryNoteNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_added_count, emoji_used, note_character_length, emoji_added, emoji_suggested_count, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, sticker_added, media_id_added, story_id, story_structure_design, media_type, media_added, suggestion_logic_type, suggestion_mapped_keyword, suggestion_emoji_selected, suggestion_theme_selected, suggestion_used',
  ...props,
})

Events.p2p_amount_story_note_back_pressed = (props: CGPropsP2pAmountStoryNoteBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_story_note_typing_started = (props: CGPropsP2pAmountStoryNoteTypingStarted) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_typing_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_amount_story_note_input_field_focused = (props: CGPropsP2pAmountStoryNoteInputFieldFocused) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_input_field_focused',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, send_currency, receive_currency, receiver_metadata_shown, send_value, receive_value',
  ...props,
})

Events.p2p_amount_story_note_theme_entry_point_pressed = (props: CGPropsP2pAmountStoryNoteThemeEntryPointPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_theme_entry_point_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, story_structure_design, note_screen_design',
  ...props,
})

Events.p2p_amount_story_note_gif_entry_point_pressed = (props: CGPropsP2pAmountStoryNoteGifEntryPointPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_entry_point_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, story_structure_design, note_screen_design',
  ...props,
})

Events.p2p_amount_story_note_gif_selected_pressed = (props: CGPropsP2pAmountStoryNoteGifSelectedPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_selected_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, gif_source, media_id_added',
  ...props,
})

Events.p2p_amount_story_note_gif_menu_pressed = (props: CGPropsP2pAmountStoryNoteGifMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_story_note_gif_menu_replace_pressed = (props: CGPropsP2pAmountStoryNoteGifMenuReplacePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_menu_replace_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_story_note_gif_menu_remove_pressed = (props: CGPropsP2pAmountStoryNoteGifMenuRemovePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_menu_remove_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_story_note_gif_menu_cancel_pressed = (props: CGPropsP2pAmountStoryNoteGifMenuCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_gif_menu_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added',
  ...props,
})

Events.p2p_amount_story_note_media_selected_pressed = (props: CGPropsP2pAmountStoryNoteMediaSelectedPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_media_selected_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, gif_source, media_id_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_story_note_media_menu_pressed = (props: CGPropsP2pAmountStoryNoteMediaMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_media_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_story_note_media_menu_replace_pressed = (props: CGPropsP2pAmountStoryNoteMediaMenuReplacePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_media_menu_replace_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_story_note_media_menu_remove_pressed = (props: CGPropsP2pAmountStoryNoteMediaMenuRemovePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_media_menu_remove_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_story_note_media_menu_cancel_pressed = (props: CGPropsP2pAmountStoryNoteMediaMenuCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_story_note_media_menu_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, media_id_added, story_structure_design, media_type, media_added',
  ...props,
})

Events.p2p_amount_alert_occurred = (props: CGPropsP2pAmountAlertOccurred) => ({
  ...commonProps,
  event_type: 'ac',
  error_desc: 'enter_note',
  event_name: 'p2p_amount_alert_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, error_desc',
  ...props,
})

Events.p2p_amount_story_note_error_occurred = (props: CGPropsP2pAmountStoryNoteErrorOccurred) => ({
  ...commonProps,
  event_type: 'ac',
  error_desc: 'enter_note',
  event_name: 'p2p_amount_story_note_error_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, error_desc',
  ...props,
})

Events.p2p_amount_gift_pressed = (props: CGPropsP2pAmountGiftPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gift_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_account_type, receiver_country, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, page_variant, story_structure_design, media_id_added, media_type, media_added, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_amount_gift_theme_pressed = (props: CGPropsP2pAmountGiftThemePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gift_theme_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_account_type, receiver_country, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, page_variant, story_structure_design, media_id_added, media_type, media_added, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_amount_gift_theme_save_pressed = (props: CGPropsP2pAmountGiftThemeSavePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_amount_gift_theme_save_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_account_type, receiver_country, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, page_variant, story_structure_design, media_id_added, media_type, media_added, send_currency, receive_currency, receiver_metadata_shown',
  ...props,
})

Events.p2p_fx_back_pressed = (props: CGPropsP2pFxBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fx_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_browse_theme_options_shown = (props: CGPropsP2pBrowseThemeOptionsShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_browse_theme_options_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_added_count, emoji_used, note_character_length, emoji_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, category_options_offered_count, theme_options_offered_count',
  ...props,
})

Events.p2p_browse_theme_options_selection = (props: CGPropsP2pBrowseThemeOptionsSelection) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_browse_theme_options_selection',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_added_count, emoji_used, note_character_length, emoji_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, category_id, category_carousel_theme_order, skin_tone, category_name, theme_name, category_vertical_order',
  ...props,
})

Events.p2p_browse_theme_options_dismissed = (props: CGPropsP2pBrowseThemeOptionsDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_browse_theme_options_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_browse_theme_options_category_scroll_right = (props: CGPropsP2pBrowseThemeOptionsCategoryScrollRight) => ({
  ...commonProps,
  event_type: 'sd',
  event_name: 'p2p_browse_theme_options_category_scroll_right',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, scroll_depth, scroll_threshold, category_name',
  ...props,
})

Events.p2p_browse_theme_options_category_scroll_down = (props: CGPropsP2pBrowseThemeOptionsCategoryScrollDown) => ({
  ...commonProps,
  event_type: 'sd',
  event_name: 'p2p_browse_theme_options_category_scroll_down',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, scroll_depth, scroll_threshold',
  ...props,
})

Events.p2p_browse_theme_options_skin_tone_selector_shown = (props: CGPropsP2pBrowseThemeOptionsSkinToneSelectorShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_browse_theme_options_skin_tone_selector_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, skin_tone_options_offered',
  ...props,
})

Events.p2p_browse_theme_options_skin_tone_selected = (props: CGPropsP2pBrowseThemeOptionsSkinToneSelected) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_browse_theme_options_skin_tone_selected',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, skin_tone',
  ...props,
})

Events.p2p_browse_theme_options_skin_tone_selector_long_press = (props: CGPropsP2pBrowseThemeOptionsSkinToneSelectorLongPress) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_browse_theme_options_skin_tone_selector_long_press',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, skin_tone',
  ...props,
})

Events.p2p_fi_unavailable_payment_methods_screen_shown = (props: CGPropsP2pFiUnavailablePaymentMethodsScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_fi_unavailable_payment_methods_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, screen_state, fi_count_shown',
  ...props,
})

Events.p2p_fi_unavailable_payment_methods_screen_primary_button_pressed = (props: CGPropsP2pFiUnavailablePaymentMethodsScreenPrimaryButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_unavailable_payment_methods_screen_primary_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, button_name',
  ...props,
})

Events.p2p_fi_screen_unavailable_payment_methods_link_pressed = (props: CGPropsP2pFiScreenUnavailablePaymentMethodsLinkPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_screen_unavailable_payment_methods_link_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_fi_unavailable_payment_methods_screen_back_pressed = (props: CGPropsP2pFiUnavailablePaymentMethodsScreenBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_unavailable_payment_methods_screen_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_add_fi_screen_shown = (props: CGPropsP2pAddFiScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_add_fi_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_fi_screen_dismissed = (props: CGPropsP2pFiScreenDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_screen_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_fi_warning_close_pressed = (props: CGPropsP2pFiWarningClosePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_warning_close_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_fi_warning_continue_pressed = (props: CGPropsP2pFiWarningContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_warning_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_fi_warning_screen_shown = (props: CGPropsP2pFiWarningScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_fi_warning_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, chosen_fi_id, fi_warning_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added',
  ...props,
})

Events.p2p_fi_warning_update_pressed = (props: CGPropsP2pFiWarningUpdatePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_warning_update_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_fi_warning_terms_pressed = (props: CGPropsP2pFiWarningTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_warning_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_fi_add_pressed = (props: CGPropsP2pFiAddPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_add_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_fi_back_pressed = (props: CGPropsP2pFiBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_fi_screen_shown = (props: CGPropsP2pFiScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_fi_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_eligible_count, default_fi, balance_available, unavailable_payment_methods_link_shown, page_alert_shown, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type',
  ...props,
})

Events.p2p_fi_next_pressed = (props: CGPropsP2pFiNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_selected, default_fi, balance_toggle, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, fi_type, fi_name, fi_id, balance_used, funding_option, fi_has_bufs',
  ...props,
})

Events.p2p_fi_selection_pressed = (props: CGPropsP2pFiSelectionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_selection_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type, fi_selection_switched, funding_option, fi_has_bufs',
  ...props,
})

Events.p2p_fi_selection_warning_pressed = (props: CGPropsP2pFiSelectionWarningPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_fi_selection_warning_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_fi_contingency_called = (props: CGPropsP2pFiContingencyCalled) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_fi_contingency_called',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, chosen_fi_id, contingency_return',
  ...props,
})

Events.p2p_fi_contingency_resolved = (props: CGPropsP2pFiContingencyResolved) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_fi_contingency_resolved',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, chosen_fi_id, contingency_return, status',
  ...props,
})

Events.p2p_review_note_back_pressed = (props: CGPropsP2pReviewNoteBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_note_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_note_done_pressed = (props: CGPropsP2pReviewNoteDonePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_note_done_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, emoji_count, emoji_included, note_character_length',
  ...props,
})

Events.p2p_review_note_screen_shown = (props: CGPropsP2pReviewNoteScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_review_note_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_note_typing_started = (props: CGPropsP2pReviewNoteTypingStarted) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_note_typing_started',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_payment_type_back_pressed = (props: CGPropsP2pPaymentTypeBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_payment_type_toggle_pressed = (props: CGPropsP2pPaymentTypeTogglePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_toggle_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, payment_type, suggested_protection_design, protection_design',
  ...props,
})

Events.p2p_payment_type_cancel_pressed = (props: CGPropsP2pPaymentTypeCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, suggested_protection_design, protection_design',
  ...props,
})

Events.p2p_payment_type_screen_shown = (props: CGPropsP2pPaymentTypeScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_payment_type_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, suggested_protection_design, protection_design, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type_selection_message, page_variant',
  ...props,
})

Events.p2p_payment_type_transition_message = (props: CGPropsP2pPaymentTypeTransitionMessage) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_payment_type_transition_message',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_payment_type_terms_pressed = (props: CGPropsP2pPaymentTypeTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, suggested_protection_design, protection_design',
  ...props,
})

Events.p2p_payment_type_fee_payer_option_pressed = (props: CGPropsP2pPaymentTypeFeePayerOptionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_fee_payer_option_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, suggested_protection_design, protection_design, fee_payer',
  ...props,
})

Events.p2p_payment_type_continue_pressed = (props: CGPropsP2pPaymentTypeContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_payment_type_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, suggested_protection_design, protection_design, fee_payer',
  ...props,
})

Events.p2p_protection_overpanel_shown = (props: CGPropsP2pProtectionOverpanelShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_protection_overpanel_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_protection_overpanel_back_pressed = (props: CGPropsP2pProtectionOverpanelBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_protection_overpanel_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_protection_overpanel_dismissed = (props: CGPropsP2pProtectionOverpanelDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_protection_overpanel_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_protection_overpanel_gns_pressed = (props: CGPropsP2pProtectionOverpanelGnsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_protection_overpanel_gns_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_protection_overpanel_fnf_pressed = (props: CGPropsP2pProtectionOverpanelFnfPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_protection_overpanel_fnf_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_seller_fee_disclaimer_screen_shown = (props: CGPropsP2pSellerFeeDisclaimerScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_seller_fee_disclaimer_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_seller_fee_disclaimer_ok_pressed = (props: CGPropsP2pSellerFeeDisclaimerOkPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_seller_fee_disclaimer_ok_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_seller_fee_disclaimer_terms_pressed = (props: CGPropsP2pSellerFeeDisclaimerTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_seller_fee_disclaimer_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_screen_dismissed = (props: CGPropsP2pReviewScreenDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_screen_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_about_seller_fee_pressed = (props: CGPropsP2pReviewAboutSellerFeePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_about_seller_fee_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_close_pressed = (props: CGPropsP2pReviewClosePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_close_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.p2p_review_add_note_pressed = (props: CGPropsP2pReviewAddNotePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_add_note_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_back_pressed = (props: CGPropsP2pReviewBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_screen_shown = (props: CGPropsP2pReviewScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_review_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fee, fi_warning_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, suggested_protection_design, protection_design, fee_payer, page_variant, sticker_added, media_id_added, story_structure_design, story_id, media_type, media_added, tip_amount, suggestion_logic_type, suggestion_mapped_keyword, suggestion_emoji_selected, suggestion_theme_selected, suggestion_used, disclaimer_shown, sender_amount, receiver_amount_local_currency, default_fi_type, fi_name, balance_used, payment_type_review_message, is_check_box_shown, estimated_funds_arrival_time, send_to_flow, fi_has_bufs',
  ...props,
})

Events.active_consent_disclaimer_shown = (props: CGPropsActiveConsentDisclaimerShown) => ({
  ...commonProps,
  product: 'p2p',
  event_type: 'im',
  event_name: 'active_consent_disclaimer_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, product, event_type, flow, policy_minor_version, policy_major_version',
  ...props,
})

Events.active_consent_disclaimer_agree_pressed = (props: CGPropsActiveConsentDisclaimerAgreePressed) => ({
  ...commonProps,
  product: 'p2p',
  event_type: 'cl',
  event_name: 'active_consent_disclaimer_agree_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, product, event_type, flow, policy_minor_version, policy_major_version',
  ...props,
})

Events.active_consent_disclaimer_terms_pressed = (props: CGPropsActiveConsentDisclaimerTermsPressed) => ({
  ...commonProps,
  product: 'p2p',
  event_type: 'cl',
  event_name: 'active_consent_disclaimer_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, product, event_type, flow, policy_minor_version, policy_major_version',
  ...props,
})

Events.p2p_review_fi_pressed = (props: CGPropsP2pReviewFiPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_fi_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_protection_choice_pressed = (props: CGPropsP2pReviewProtectionChoicePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_protection_choice_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_submit_pressed = (props: CGPropsP2pReviewSubmitPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_submit_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fee, fi_warning_type, sender_currency, receiver_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, suggested_protection_design, protection_design, fee_payer, sticker_added, media_id_added, story_structure_design, story_id, media_type, media_added, suggestion_logic_type, suggestion_mapped_keyword, suggestion_emoji_selected, suggestion_theme_selected, suggestion_used, fi_type, fi_name, balance_used, payment_type_review_message, gns_consent, send_to_flow',
  ...props,
})

Events.p2p_review_payment_type_terms_pressed = (props: CGPropsP2pReviewPaymentTypeTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_payment_type_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_shipping_address_pressed = (props: CGPropsP2pReviewShippingAddressPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_shipping_address_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_review_warning_pressed = (props: CGPropsP2pReviewWarningPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_review_warning_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, fi_warning_type',
  ...props,
})

Events.p2p_24_hr_hold_cancel_pressed = (props: CGPropsP2p24HrHoldCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_24_hr_hold_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, page_variant',
  ...props,
})

Events.p2p_24_hr_hold_continue_pressed = (props: CGPropsP2p24HrHoldContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_24_hr_hold_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, page_variant',
  ...props,
})

Events.p2p_24_hr_hold_screen_shown = (props: CGPropsP2p24HrHoldScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_24_hr_hold_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, page_variant, action',
  ...props,
})

Events.p2p_success_done_pressed = (props: CGPropsP2pSuccessDonePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_done_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.p2p_success_screen_shown = (props: CGPropsP2pSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_success_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, suggested_protection_design, protection_design, fee_payer, page_variant, sticker_added, media_id_added, story_structure_design, story_id, media_type, design_mgm, media_added, tip_amount, txn_id, feedback_available, suggestion_logic_type, suggestion_mapped_keyword, suggestion_emoji_selected, suggestion_theme_selected, suggestion_used, send_to_flow',
  ...props,
})

Events.p2p_success_mgm_terms_pressed = (props: CGPropsP2pSuccessMgmTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_mgm_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_success_restart_pressed = (props: CGPropsP2pSuccessRestartPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_restart_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_success_summary_pressed = (props: CGPropsP2pSuccessSummaryPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_summary_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_success_invite_friend_pressed = (props: CGPropsP2pSuccessInviteFriendPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_invite_friend_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_success_screen_feedback_pressed = (props: CGPropsP2pSuccessScreenFeedbackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_success_screen_feedback_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_request_money_seller_profile_entry_screen_shown = (props: CGPropsP2pRequestMoneySellerProfileEntryScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_request_money_seller_profile_entry_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, response_duration',
  ...props,
})

Events.p2p_request_money_seller_profile_entry_create_pressed = (props: CGPropsP2pRequestMoneySellerProfileEntryCreatePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_request_money_seller_profile_entry_create_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_request_money_seller_profile_entry_dismiss_pressed = (props: CGPropsP2pRequestMoneySellerProfileEntryDismissPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_request_money_seller_profile_entry_dismiss_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_failed_customer_interaction_occurred = (props: CGPropsP2pFailedCustomerInteractionOccurred) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_failed_customer_interaction_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, error_code, error_description, screen',
  ...props,
})

Events.p2p_non_visible_error_occurred = (props: CGPropsP2pNonVisibleErrorOccurred) => ({
  ...commonProps,
  event_type: 'err',
  event_name: 'p2p_non_visible_error_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, file_name, function_name, description',
  ...props,
})

Events.p2p_physical_back_button_pressed = (props: CGPropsP2pPhysicalBackButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_physical_back_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, screen',
  ...props,
})

Events.p2p_story_landing_screen_loading_called = (props: CGPropsP2pStoryLandingScreenLoadingCalled) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_story_landing_screen_loading_called',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, payment_type, story_id',
  ...props,
})

Events.p2p_story_landing_screen_shown = (props: CGPropsP2pStoryLandingScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, media_id_added, story_id, txn_id, request_id, group_request_id, user_role, status, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, two_way_experience_active',
  ...props,
})

Events.p2p_story_landing_back_button_pressed = (props: CGPropsP2pStoryLandingBackButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_back_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, media_id_added, story_id, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_done_pressed = (props: CGPropsP2pStoryLandingDonePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_done_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, media_id_added, story_id, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_view_details_pressed = (props: CGPropsP2pStoryLandingViewDetailsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_view_details_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, emoji_added_count, emoji_used, note_character_length, emoji_added, payment_type, media_id_added, story_id, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, two_way_experience_active',
  ...props,
})

Events.p2p_story_landing_pay_request_pressed = (props: CGPropsP2pStoryLandingPayRequestPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_pay_request_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, request_id, group_request_id',
  ...props,
})

Events.p2p_story_landing_cancel_request_pressed = (props: CGPropsP2pStoryLandingCancelRequestPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_cancel_request_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, request_id, group_request_id, user_role',
  ...props,
})

Events.p2p_story_landing_confirm_cancel_request_menu_pressed = (props: CGPropsP2pStoryLandingConfirmCancelRequestMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_confirm_cancel_request_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, request_id, group_request_id, user_role',
  ...props,
})

Events.p2p_story_landing_dismiss_request_cancel_menu_pressed = (props: CGPropsP2pStoryLandingDismissRequestCancelMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_dismiss_request_cancel_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, request_id, group_request_id, user_role',
  ...props,
})

Events.p2p_story_landing_screen_decline_request_menu_shown = (props: CGPropsP2pStoryLandingScreenDeclineRequestMenuShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_screen_decline_request_menu_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, request_id, group_request_id, user_role',
  ...props,
})

Events.p2p_story_landing_quick_reaction_start_button_pressed = (props: CGPropsP2pStoryLandingQuickReactionStartButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_quick_reaction_start_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, previous_quick_reaction_selected, transaction_type, note_added, note_character_length, emoji_added_count, emoji_used, emoji_added, media_id_added, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_message_start_button_pressed = (props: CGPropsP2pStoryLandingMessageStartButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_start_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, transaction_type, note_added, note_character_length, emoji_added_count, emoji_used, emoji_added, media_id_added, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_view_messages_pressed = (props: CGPropsP2pStoryLandingViewMessagesPressed) => ({
  ...commonProps,
  event_type: 'cl',
  product: 'p2p',
  event_name: 'p2p_story_landing_view_messages_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, product',
  ...props,
})

Events.p2p_story_landing_chat_thread_open_button_pressed = (props: CGPropsP2pStoryLandingChatThreadOpenButtonPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_chat_thread_open_button_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, transaction_type, note_added, note_character_length, emoji_added_count, emoji_used, emoji_added, media_id_added, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_quick_reaction_options_shown = (props: CGPropsP2pStoryLandingQuickReactionOptionsShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_quick_reaction_options_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, reaction_options_offered_count, reaction_options_offered_value',
  ...props,
})

Events.p2p_story_landing_quick_reaction_options_pressed = (props: CGPropsP2pStoryLandingQuickReactionOptionsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_quick_reaction_options_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, reaction_options_selected',
  ...props,
})

Events.p2p_story_landing_quick_reaction_options_dismissed = (props: CGPropsP2pStoryLandingQuickReactionOptionsDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_quick_reaction_options_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, previous_quick_reaction_selected, reaction_options_offered_count, reaction_options_offered_value',
  ...props,
})

Events.p2p_story_landing_quick_reaction_failed_shown = (props: CGPropsP2pStoryLandingQuickReactionFailedShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_quick_reaction_failed_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_thread_shown = (props: CGPropsP2pStoryLandingMessageThreadShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_thread_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, transaction_type, note_added, note_character_length, emoji_added_count, emoji_used, emoji_added, media_id_added, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency, blocked_relationship, txn_id',
  ...props,
})

Events.p2p_story_landing_message_thread_error_shown = (props: CGPropsP2pStoryLandingMessageThreadErrorShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_thread_error_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, error_code, error_description',
  ...props,
})

Events.p2p_story_landing_message_thread_disclaimer_link_pressed = (props: CGPropsP2pStoryLandingMessageThreadDisclaimerLinkPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_thread_disclaimer_link_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_thread_dismissed = (props: CGPropsP2pStoryLandingMessageThreadDismissed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_thread_dismissed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, dismiss_method',
  ...props,
})

Events.p2p_story_landing_message_send_pressed = (props: CGPropsP2pStoryLandingMessageSendPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_send_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, source, story_id, transaction_type, user_role, note_added, note_character_length, emoji_added_count, emoji_used, emoji_added, media_id_added, media_type, media_added, sender_currency, receiver_currency, sender_amount, receiver_amount_local_currency',
  ...props,
})

Events.p2p_story_landing_message_thread_profile_pressed = (props: CGPropsP2pStoryLandingMessageThreadProfilePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_thread_profile_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_thread_refresh_action_shown = (props: CGPropsP2pStoryLandingMessageThreadRefreshActionShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_thread_refresh_action_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_thread_refresh_dragged = (props: CGPropsP2pStoryLandingMessageThreadRefreshDragged) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_thread_refresh_dragged',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_more_options_menu_pressed = (props: CGPropsP2pStoryLandingMessageMoreOptionsMenuPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_more_options_menu_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_more_options_menu_block_pressed = (props: CGPropsP2pStoryLandingMessageMoreOptionsMenuBlockPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_more_options_menu_block_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_more_options_menu_report_pressed = (props: CGPropsP2pStoryLandingMessageMoreOptionsMenuReportPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_more_options_menu_report_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_confirmation_alert_shown = (props: CGPropsP2pStoryLandingMessageBlockConfirmationAlertShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_block_confirmation_alert_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_confirmation_alert_block_pressed = (props: CGPropsP2pStoryLandingMessageBlockConfirmationAlertBlockPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_block_confirmation_alert_block_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, blocking_user, blocked_user, txn_id, story_id',
  ...props,
})

Events.p2p_story_landing_message_block_confirmation_alert_cancel_pressed = (props: CGPropsP2pStoryLandingMessageBlockConfirmationAlertCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_block_confirmation_alert_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_success_shown = (props: CGPropsP2pStoryLandingMessageBlockSuccessShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_block_success_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_success_close_pressed = (props: CGPropsP2pStoryLandingMessageBlockSuccessClosePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_block_success_close_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_failed_shown = (props: CGPropsP2pStoryLandingMessageBlockFailedShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_story_landing_message_block_failed_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_story_landing_message_block_failed_close_pressed = (props: CGPropsP2pStoryLandingMessageBlockFailedClosePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_story_landing_message_block_failed_close_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_app_store_screen_shown = (props: CGPropsP2pAppStoreScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_app_store_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_app_store_close_pressed = (props: CGPropsP2pAppStoreClosePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_app_store_close_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_app_store_download_pressed = (props: CGPropsP2pAppStoreDownloadPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_app_store_download_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_client_server_decision_reached = (props: CGPropsP2pClientServerDecisionReached) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_client_server_decision_reached',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, product_entry_point, decision_action, default_payment_type, ui_variant, payment_type_selection_behavior, service_client_match, usage_mode, reassess_capabilities',
  ...props,
})

Events.p2p_mgm_interstitial_screen_shown = (props: CGPropsP2pMgmInterstitialScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_mgm_interstitial_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_terms_pressed = (props: CGPropsP2pMgmTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_interstitial_next_pressed = (props: CGPropsP2pMgmInterstitialNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_interstitial_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_interstitial_back_pressed = (props: CGPropsP2pMgmInterstitialBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_interstitial_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_criteria_screen_shown = (props: CGPropsP2pMgmReceiverCriteriaScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_mgm_receiver_criteria_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_criteria_add_fi_pressed = (props: CGPropsP2pMgmReceiverCriteriaAddFiPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_receiver_criteria_add_fi_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_criteria_spend_pressed = (props: CGPropsP2pMgmReceiverCriteriaSpendPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_receiver_criteria_spend_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_criteria_back_pressed = (props: CGPropsP2pMgmReceiverCriteriaBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_receiver_criteria_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_delayed_payout_screen_invite_pressed = (props: CGPropsP2pMgmReceiverDelayedPayoutScreenInvitePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_mgm_receiver_delayed_payout_screen_invite_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_mgm_receiver_delayed_payout_screen_shown = (props: CGPropsP2pMgmReceiverDelayedPayoutScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_mgm_receiver_delayed_payout_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_rtr_screen_shown = (props: CGPropsP2pRtrScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_rtr_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_rtr_screen_back_pressed = (props: CGPropsP2pRtrScreenBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_rtr_screen_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_rtr_screen_next_pressed = (props: CGPropsP2pRtrScreenNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_rtr_screen_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_external_entry_occurred = (props: CGPropsP2pExternalEntryOccurred) => ({
  ...commonProps,
  event_type: 'ac',
  event_name: 'p2p_external_entry_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, flow_from, http_params',
  ...props,
})

Events.p2p_search_result_contact_selection_pressed = (props: CGPropsP2pSearchResultContactSelectionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_search_result_contact_selection_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, contact_selected_row, is_recent_contact, is_existing_contact, is_favorite_contact, has_ppme, has_profile_photo, is_unilateral, mutual_contacts_status, mutual_contacts_count, is_location_shown, is_synced_contact, contact_selected_group, contact_selected_sent_count, contact_selected_rcvd_count, num_characters_input',
  ...props,
})

Events.p2p_guest_payment_form_screen_shown = (props: CGPropsP2pGuestPaymentFormScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_guest_payment_form_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_guest_payment_form_account_toggle_pressed = (props: CGPropsP2pGuestPaymentFormAccountTogglePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_guest_payment_form_account_toggle_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, toggle_on',
  ...props,
})

Events.p2p_guest_payment_form_continue_pressed = (props: CGPropsP2pGuestPaymentFormContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_guest_payment_form_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, toggle_on',
  ...props,
})

Events.p2p_guest_payment_form_dismiss_pressed = (props: CGPropsP2pGuestPaymentFormDismissPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_guest_payment_form_dismiss_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_guest_payment_review_screen_shown = (props: CGPropsP2pGuestPaymentReviewScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_guest_payment_review_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_guest_payment_review_pay_pressed = (props: CGPropsP2pGuestPaymentReviewPayPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_guest_payment_review_pay_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_guest_payment_success_screen_shown = (props: CGPropsP2pGuestPaymentSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_guest_payment_success_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_guest_payment_account_upgrade_success_screen_shown = (props: CGPropsP2pGuestPaymentAccountUpgradeSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_guest_payment_account_upgrade_success_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_first_transaction_free_interstitial_shown = (props: CGPropsP2pFirstTransactionFreeInterstitialShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_first_transaction_free_interstitial_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_first_transaction_free_interstitial_send_pressed = (props: CGPropsP2pFirstTransactionFreeInterstitialSendPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_first_transaction_free_interstitial_send_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_first_transaction_free_interstitial_dismiss_pressed = (props: CGPropsP2pFirstTransactionFreeInterstitialDismissPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_first_transaction_free_interstitial_dismiss_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, dismiss_method',
  ...props,
})

Events.p2p_contact_first_transaction_free_terms_pressed = (props: CGPropsP2pContactFirstTransactionFreeTermsPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_contact_first_transaction_free_terms_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.p2p_checkout_success_continue_shopping_pressed = (props: CGPropsP2pCheckoutSuccessContinueShoppingPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_checkout_success_continue_shopping_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, txn_id, store_id',
  ...props,
})

Events.p2p_checkout_success_screen_shown = (props: CGPropsP2pCheckoutSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_checkout_success_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, txn_id, store_id',
  ...props,
})

Events.visatag_balance_screen_shown = (props: CGPropsVisatagBalanceScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'visatag_balance_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, has_balance',
  ...props,
})

Events.visatag_balance_continue_pressed = (props: CGPropsVisatagBalanceContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_balance_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.visatag_balance_add_money_pressed = (props: CGPropsVisatagBalanceAddMoneyPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_balance_add_money_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.visatag_balance_cancel_pressed = (props: CGPropsVisatagBalanceCancelPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_balance_cancel_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type',
  ...props,
})

Events.visatag_contact_screen_shown = (props: CGPropsVisatagContactScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'visatag_contact_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_contact_contact_field_pressed = (props: CGPropsVisatagContactContactFieldPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_contact_contact_field_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_contact_next_pressed = (props: CGPropsVisatagContactNextPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_contact_next_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, response_status, send_to_flow',
  ...props,
})

Events.visatag_contact_back_pressed = (props: CGPropsVisatagContactBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_contact_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_phone_validation_screen_shown = (props: CGPropsVisatagPhoneValidationScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'visatag_phone_validation_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_phone_validation_skip_pressed = (props: CGPropsVisatagPhoneValidationSkipPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_phone_validation_skip_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_phone_validation_confirm_pressed = (props: CGPropsVisatagPhoneValidationConfirmPressed) => ({
  ...commonProps,
  event_type: 'cl',
  flow_step: 'phone_validation',
  event_name: 'visatag_phone_validation_confirm_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, flow_step, response_status, send_to_flow',
  ...props,
})

Events.visatag_phone_validation_back_pressed = (props: CGPropsVisatagPhoneValidationBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_phone_validation_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_disallow_paypal_payname_screen_shown = (props: CGPropsVisatagDisallowPaypalPaynameScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'visatag_disallow_paypal_payname_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_disallow_paypal_payname_p2p_pressed = (props: CGPropsVisatagDisallowPaypalPaynameP2pPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_disallow_paypal_payname_p2p_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_disallow_paypal_payname_back_pressed = (props: CGPropsVisatagDisallowPaypalPaynameBackPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'visatag_disallow_paypal_payname_back_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.visatag_phone_validation_success_screen_shown = (props: CGPropsVisatagPhoneValidationSuccessScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'visatag_phone_validation_success_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, send_to_flow',
  ...props,
})

Events.p2p_personal_profile_create_continue_pressed = (props: CGPropsP2pPersonalProfileCreateContinuePressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_personal_profile_create_continue_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_failure_returned = (props: CGPropsP2pPersonalProfileCreateFailureReturned) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_personal_profile_create_failure_returned',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_form_error_occurred = (props: CGPropsP2pPersonalProfileCreateFormErrorOccurred) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_personal_profile_create_form_error_occurred',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_edit_pressed = (props: CGPropsP2pPersonalProfileCreateEditPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_personal_profile_create_edit_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_not_now_pressed = (props: CGPropsP2pPersonalProfileCreateNotNowPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_personal_profile_create_not_now_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_screen_shown = (props: CGPropsP2pPersonalProfileCreateScreenShown) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_personal_profile_create_screen_shown',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_success_returned = (props: CGPropsP2pPersonalProfileCreateSuccessReturned) => ({
  ...commonProps,
  event_type: 'im',
  event_name: 'p2p_personal_profile_create_success_returned',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

Events.p2p_personal_profile_create_suggestion_pressed = (props: CGPropsP2pPersonalProfileCreateSuggestionPressed) => ({
  ...commonProps,
  event_type: 'cl',
  event_name: 'p2p_personal_profile_create_suggestion_pressed',
  event_props: 'sub_flow, session_id, source, p2p_attempt_id, p2p_contacts_synced_current_app_permissions, sender_account_type, sender_country, receiver_account_type, receiver_country, product, event_type, entry_point',
  ...props,
})

// export

export default Events